export default __webpack_public_path__ + "static/media/facility_02_6.ffc83737.png";